import { rideshareOptions } from '../../../mocks/transportationPage';

export default function RideshareSection() {
  return (
    <section id="rideshare" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12">
          <span className="inline-block bg-amber-100 text-amber-700 px-4 py-1.5 rounded-full text-xs font-semibold uppercase tracking-wide mb-4">
            Rideshare &amp; Taxis
          </span>
          <h2 className="text-3xl font-bold text-gray-900 mb-4">On-Demand Rides</h2>
          <p className="text-gray-600 max-w-2xl mx-auto text-sm">
            Get a ride anytime with popular rideshare apps or traditional taxi services operating throughout Roseville.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {rideshareOptions.map((option) => (
            <div
              key={option.id}
              className="bg-white rounded-2xl p-6 shadow-sm border border-gray-100 hover:shadow-lg transition-all group"
            >
              <div className="w-14 h-14 bg-amber-50 rounded-xl flex items-center justify-center mb-5 group-hover:bg-amber-100 transition-colors">
                <i className={`${option.icon} text-2xl text-amber-600`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">{option.name}</h3>
              <p className="text-gray-600 text-sm mb-4">{option.description}</p>

              <div className="space-y-3 mb-5">
                <div className="flex items-center justify-between text-sm">
                  <span className="text-gray-500">Avg. Wait</span>
                  <span className="font-semibold text-gray-900">{option.avgWait}</span>
                </div>
                <div className="flex items-center justify-between text-sm">
                  <span className="text-gray-500">Price Range</span>
                  <span className="font-semibold text-gray-900">{option.priceRange}</span>
                </div>
              </div>

              <div className="flex flex-wrap gap-2 mb-5">
                {option.features.map((feature, idx) => (
                  <span
                    key={idx}
                    className="text-xs bg-gray-100 text-gray-700 px-3 py-1 rounded-full"
                  >
                    {feature}
                  </span>
                ))}
              </div>

              <a
                href={option.link}
                target="_blank"
                rel="noopener noreferrer"
                className="block w-full text-center bg-amber-500 hover:bg-amber-600 text-white py-2.5 rounded-lg text-sm font-semibold transition-colors cursor-pointer whitespace-nowrap"
              >
                {option.name === 'Yellow Cab Roseville' ? 'Call Now' : 'Open App'}
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
